import { useMemo } from 'react';
import { generateStretchablePinVariants } from '../utils/svgDefinitions/createTrailLengthPinSvg';
import createTrailPinSvg, { PRIORITY_HIGH_FILL, PRIORITY_LOW_FILL, PRIORITY_MEDIUM_FILL } from '../utils/svgDefinitions/createTrailPinSvg';
import {
  trailPinCollapsedClosedImageName,
  trailPinCollapsedCompletedImageName,
  trailPinCollapsedImageName,
  trailPinCollapsedPriorityHighImageName,
  trailPinCollapsedPriorityLowImageName,
  trailPinCollapsedPriorityMediumImageName,
  trailPinCollapsedSavedImageName,
  trailPinCollapsedViewedImageName
} from '../utils/trailPinConstants';
import { SvgDefinition } from '../utils/useSvgImages';

export default function useTrailPinSvgDefinitions() {
  const svgDefinitions = useMemo(() => {
    const definitions: SvgDefinition[] = [];

    definitions.push(
      createTrailPinSvg({ imageName: trailPinCollapsedImageName, trailCount: 1, isCollapsed: true }),
      createTrailPinSvg({
        imageName: trailPinCollapsedClosedImageName,
        trailCount: 1,
        isClosed: true,
        isCollapsed: true
      }),
      createTrailPinSvg({
        imageName: trailPinCollapsedSavedImageName,
        trailCount: 1,
        isSaved: true,
        isCollapsed: true
      }),
      createTrailPinSvg({
        imageName: trailPinCollapsedCompletedImageName,
        trailCount: 1,
        isCompleted: true,
        isCollapsed: true
      })
    );

    definitions.push(
      createTrailPinSvg({
        imageName: trailPinCollapsedViewedImageName,
        trailCount: 1,
        isCollapsed: true,
        isViewed: true
      })
    );

    definitions.push(
      createTrailPinSvg({ imageName: trailPinCollapsedPriorityHighImageName, trailCount: 1, isCollapsed: true, priorityFill: PRIORITY_HIGH_FILL }),
      createTrailPinSvg({
        imageName: trailPinCollapsedPriorityMediumImageName,
        trailCount: 1,
        isCollapsed: true,
        priorityFill: PRIORITY_MEDIUM_FILL
      }),
      createTrailPinSvg({ imageName: trailPinCollapsedPriorityLowImageName, trailCount: 1, isCollapsed: true, priorityFill: PRIORITY_LOW_FILL })
    );

    // Generate stretchable pill-shaped pin SVGs (3 states x 7 types)
    // These use icon-text-fit to dynamically stretch to fit text content
    definitions.push(...generateStretchablePinVariants());

    return definitions;
  }, []);

  return svgDefinitions;
}
